import {RouterProvider} from '@wandb/components';
import {ToastContainer} from '@wandb/weave/common/components/elements/Toast';
import React, {useEffect} from 'react';
import {useHistory} from 'react-router-dom';

import AddEmailAlert from '../components/AddEmailAlert';
import {GlobalBannerContextProvider} from '../components/GlobalBanners/GlobalBannerContextProvider';
import MessageOfTheDay from '../components/MessageOfTheDay';
import NavContextProvider from '../components/NavContextProvider';
import {RunQueuePopoverProvider} from '../components/RunQueueItemsPopover';
import {AppSearch} from '../components/Search';
import SearchNav from '../components/Search/SearchNav';
import {LoaderProxy} from '../containers/AppLoader';
import {useSetAccessTokenFromCookieFromQS} from '../util/auth';
import {useConsentAwareAnalyticsInjection} from '../util/consentAwareAnalyticSetup';
import {setGlobalHistory, useUpdateCanonicalURL} from '../util/history';
import {useHref, useNavigate} from '../util/react-router-v6-shim';
import App from './../App';
import {AppBanners} from './AppBanners';
import {AppRoutes} from './AppRoutes';

export const AppWithRoutes = () => {
  const navigate = useNavigate();

  useConsentAwareAnalyticsInjection();
  useUpdateCanonicalURL();
  useSetAccessTokenFromCookieFromQS();

  // This is a temporary workaround to allow us to set the global history
  // and avoid creating history b/c the preferred approach is to use the
  // BrowserRouter component and capture history using the useHistory hook.
  // However, we are using the global history in redux and it is a much larger
  // effort to fix that. Sorry :(
  const history = useHistory();
  useEffect(() => {
    setGlobalHistory(history);
  }, [history]);

  return (
    <RouterProvider navigate={navigate} useHref={useHref}>
      <App>
        <GlobalBannerContextProvider>
          <RunQueuePopoverProvider>
            <NavContextProvider>
              <SearchNav />
              <AppSearch />
              <MessageOfTheDay />
              <AppBanners />
              <AddEmailAlert />
              <div className="main">
                <ToastContainer />
                <React.Suspense
                  fallback={<LoaderProxy name="fallback-loader" />}>
                  <AppRoutes />
                </React.Suspense>
              </div>
            </NavContextProvider>
          </RunQueuePopoverProvider>
        </GlobalBannerContextProvider>
      </App>
    </RouterProvider>
  );
};
